export default __webpack_public_path__ + "static/media/sendMessageButton.fc6c1d69.svg";